import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function IdealForSection() {
  const points = ['Te preparas para entrevistas pero no logras diferenciarte', 'Sientes que tienes experiencia, pero no sabes cómo comunicar tu valor', 'Quieres verte más profesional, estratégico y memorable', 'Aspiras a un puesto corporativo, gerencial o de liderazgo', 'Quieres dejar de improvisar y entrar a la entrevista con un plan'];
  return <section className="py-20 lg:py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-109">
      <FadeIn data-id="element-110">
        <div className="bg-navy rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-111">
          {/* Decorative circle */}
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-emerald/10 rounded-full blur-3xl" data-id="element-112"></div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-10 text-center relative z-10" data-id="element-113">
            Esta guía es ideal para ti si...
          </h2>

          <div className="space-y-6 relative z-10" data-id="element-114">
            {points.map((point, index) => <div key={index} className="flex items-start gap-4 bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-115">
                <CheckCircle2 className="w-6 h-6 text-emerald flex-shrink-0 mt-0.5" data-id="element-116" />
                <span className="text-white font-medium text-lg" data-id="element-117">{point}</span>
              </div>)}
          </div>
        </div>
      </FadeIn>
    </section>;
}